var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClockFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.101 16.21a.784.784 0 101.11-1.109l-3.129-3.128a1 1 0 01-.293-.707v-3.74a.79.79 0 00-1.579 0v4.38a1 1 0 00.293.707l3.598 3.598zm-3.1 5.79a9.742 9.742 0 01-3.9-.787 10.099 10.099 0 01-3.175-2.137A10.1 10.1 0 012.788 15.9a9.733 9.733 0 01-.788-3.9c0-1.382.262-2.682.787-3.9a10.1 10.1 0 012.137-3.175A10.1 10.1 0 018.1 2.788a9.733 9.733 0 013.9-.788c1.382 0 2.682.262 3.9.787a10.101 10.101 0 013.175 2.137A10.1 10.1 0 0121.212 8.1a9.733 9.733 0 01.788 3.9 9.742 9.742 0 01-.787 3.9 10.1 10.1 0 01-2.137 3.175 10.1 10.1 0 01-3.175 2.138 9.733 9.733 0 01-3.9.788z",
    fill: "currentColor"
  })));
}
SvgClockFilled.displayName = 'ClockFilled';
export default SvgClockFilled;